
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpdVisitsComponent } from './opdvisits.component';
import { OpdVisitsRoutingModule } from './opdvisits-routnig.module';
import { MaterialModule } from '../material.module';

import { LoaderComponent } from './loader/loader.component';
import { MatDialogRef } from '@angular/material/dialog';
import { AppointmentListComponent } from './appointment-list/appointment-list.component';
import {SharedModule} from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from "@angular/material/form-field";

@NgModule({
    declarations: [
        OpdVisitsComponent,
        LoaderComponent,
        AppointmentListComponent
    ],
    imports: [
   CommonModule,
   OpdVisitsRoutingModule,
   MaterialModule,
   FormsModule,
   SharedModule,
   ReactiveFormsModule,
   MatFormFieldModule
   
    ],
    providers: [
      
        {provide: MatDialogRef, useValue: {}}
     ],
    entryComponents: [
      LoaderComponent,AppointmentListComponent
    ]
   })
   export class OpdVisitModule{
   
   }